import {isEmpty} from "@helpers/helpers";
import Router from "next/router";
import {shortAgeNumber, shortAreaNumber, shortMoneyNumber} from "@helpers/numbers";
import {checkUrlParams, linkTypes} from "@models/check_link";
import {getVillaTypes} from "@models/property";
import {array_unique, inArray} from "@helpers/arrays";
import {getTypeByKey, getTypesOptions} from "@hooks/types";
import {getDistrictByIds, getDistrictOptions} from "@hooks/districts";
import {getFloorNames} from "@hooks/floors";
import {getDeeds} from "@hooks/deed";
import {getFacilitiesPersian} from "@hooks/facilities";
import {str_replace} from "../../../helpers/helpers";
import {getCityById, getDistrict, getDistricts, getTopCrowdedDistricts, getTopNearestDistricts} from "../../../../models/district";
import {
    getDealTypeSearchName,
    getPropertyTypesByCityId,
    getSearchiDealTypes,
    getTypeCaptionByName,
    getUrlDealTypes,
    getUrlTypes
} from "../../../../models/property";
import {getNorthCitiesIds} from "../../../../models/area";
import {is_array, ObjectLength} from "../../../helpers/arrays";
import {getWidgets, widgetFilters} from "../../../../models/widget";
import {getDefaultPrices} from "../../../hooks/prices";
import {getDefaultInfrastructureArea} from "../../../hooks/infrastructure_area";
import {pluckKeyToArray, UpdateSelectionOptions} from "@hooks/selection.options";
import {getDealTypeOptions} from "@hooks/deal_types";
import {citiesSelection, getDefaultCity} from "@hooks/cities";
import {getProperties} from "../../../../models/search";
import {getNorthCityData, northCitiesLanding} from "../landing/north_cities";

export function generateSearchUrl($city, $type, $deal_type, $district = null) {
    const string = '/املاک-' + str_replace(' ', '-', $city)
        + '/' + str_replace(' ', '-', $deal_type)
        + '-' + str_replace(' ', '-', $type)
        + ($district ? '/' + str_replace(' ', '-', $district) : '');
    return str_replace(' ', '-', string);
}

export const getAreaRangeTitle = (params, filed, name) => {
    let minParam = (typeof params['min_' + filed] !== "undefined") ? String(params['min_' + filed]) : '';
    let maxParam = (typeof params['max_' + filed] !== "undefined") ? String(params['max_' + filed]) : '';

    if (!isEmpty(minParam)) {
        /*if (minParam.search('+') === -1) {
            minParam.replace('+', '');
        }*/

        minParam.replace(',', '').trim();
    }

    if (!isEmpty(maxParam)) {
        /*if (maxParam.search('+') === -1) {
            maxParam.replace('+', '');
        }*/

        maxParam.replace(',', '').trim();
    }

    let title = '';

    let minValue = '';
    if (!isEmpty(minParam) && minParam > 0) {
        minValue = shortAreaNumber(minParam);
        title = minValue['num'] + ' ';
    }

    if (!isEmpty(maxParam) && maxParam > 0) {
        let maxValue = shortAreaNumber(maxParam);

        if (!isEmpty(minValue) && minValue['unit'] !== maxValue['unit']) {
            title += minValue['unit'] + ' ';
        }

        title += 'تا ' + maxValue['num'] + ' ' + maxValue['unit'];
    } else if (!isEmpty(minValue)) {
        title += minValue['unit'] + ' به بالا'
    }

    if (!isEmpty(title)) {
        title = name + ' ' + title;
    }

    return title;
};

export const getPriceRangeTitle = (params, filed, name) => {
    let minParam = (typeof params['min_' + filed] !== "undefined") ? String(params['min_' + filed]) : '';
    let maxParam = (typeof params['max_' + filed] !== "undefined") ? String(params['max_' + filed]) : '';

    if (!isEmpty(minParam)) {
        /*if (minParam.search('+') === -1) {
            minParam.replace('+', '');
        }*/

        minParam.replace(',', '').trim();
    }

    if (!isEmpty(maxParam)) {
        /*if (maxParam.search('+') === -1) {
            maxParam.replace('+', '');
        }*/

        maxParam.replace(',', '').trim();
    }

    let title = '';

    let minValue = '';
    if (!isEmpty(minParam) && minParam > 0) {
        minValue = shortMoneyNumber(minParam, '٫');
        title = minValue['num'] + ' ';
    }

    if (!isEmpty(maxParam) && maxParam > 0) {
        let maxValue = shortMoneyNumber(maxParam, '٫');

        if (!isEmpty(minValue) && minValue['unit'] !== maxValue['unit']) {
            title += minValue['unit'] + ' ';
        }

        title += 'تا ' + maxValue['num'] + ' ' + maxValue['unit'];

        if (!isEmpty(minValue) && minValue['num'] === maxValue['num']) {
            title = minValue['num'] + ' ' + minValue['unit'];
        }
    } else if (!isEmpty(minValue)) {
        title += minValue['unit'] + ' به بالا'
    }

    if (!isEmpty(title)) {
        title = name + ' ' + title;
    }

    return title;
};

export const getAgeRangeTitle = (params) => {
    let minAge = (typeof params['min_age'] !== "undefined") ? String(params['min_age']) : '';
    let maxAge = (typeof params['max_age'] !== "undefined") ? String(params['max_age']) : '';

    let title = '';
    let minValue = '';

    if (!isEmpty(minAge)) {
        minValue = shortAgeNumber(minAge);
        title = minValue['num'] + ' ';
    }

    if (!isEmpty(maxAge) && maxAge.indexOf("+") === -1) {
        let maxTitle = '';
        let maxValue = '';

        if (maxAge > 0) {
            maxValue = shortAgeNumber(maxAge);
            maxTitle += 'تا ' + maxValue['num'] + ' ' + maxValue['unit'];
        } else {
            maxAge = 'نوساز';
        }

        if (!isEmpty(minValue) && !isEmpty(maxValue) && minValue['unit'] !== maxValue['unit']) {
            title += minValue['unit'] + ' ';
        }

        title += maxTitle;

        if (!isEmpty(minValue) && !isEmpty(maxValue) && minValue['num'] === maxValue['num']) {
            title = minValue['num'] + ' ' + minValue['unit'];
        }
    } else if (!isEmpty(minValue)) {
        title += minValue['unit'] + ' به بالا';
    }

    if (!isEmpty(title)) {
        title = 'سن بنا ' + title
    }

    return title;
};

async function getSearchWidgetTitle(params) {
    let $params = JSON.parse(JSON.stringify(params));
    let searchWidgetTitleData = null;

    if (isEmpty($params['district_id']) || $params['district_id'].length === 1) {

        let city_id = $params['city_id'];
        let district_id = (!isEmpty($params['district_id']) && is_array($params['district_id']) && $params['district_id'].length === 1) ? $params['district_id'][0] : null;
        let types = [];
        let deal_type = $params['deal_type'];

        if (!isEmpty($params['types']) && $params['types'].length) {
            for (let type of $params['types']) {
                if (!isEmpty(type) && type.indexOf('.') !== -1) {
                    for (let merged of type.split('.')) {
                        if (!isEmpty(merged)) {
                            types.push(merged)
                        }
                    }
                } else if (!isEmpty(type)) {
                    types.push(type);
                }
            }
        }

        const usedParams = ['city_id', 'deal_type', 'types', 'district_id'];

        for (let item of usedParams) {
            delete $params[item];
        }

        if (ObjectLength($params) < 1) { // Do not send request when it has an extra parameter
            const widgetParams = {
                type: 'title_desc',
                page: 'properties',
                section: 'properties',
                city_id: city_id,
                district_id: [district_id],
                properties_types: types,
                properties_deal_types: deal_type,
                count: 50
            };

            const widgetTitle = await getWidgets(widgetParams);
            let selectedTitleWidget = [];

            if (!isEmpty(widgetTitle) && widgetTitle.widgets && widgetTitle.widgets.length) {
                Object.keys(widgetTitle.widgets).forEach(key => {
                    const widget = widgetTitle.widgets[key];

                    const showWidget = widgetFilters(widget, params);

                    if (showWidget) {
                        selectedTitleWidget.push(widget);
                    }
                });
            }

            if (selectedTitleWidget.length > 0) {
                searchWidgetTitleData = selectedTitleWidget[0];
            }
        }
    }

    return searchWidgetTitleData;
}

export const generateSearchTitle = async (filters, asPath) => {
    let $params = JSON.parse(JSON.stringify(filters)); // deep copy

    if (process.browser && !isEmpty($params['district_id']) && is_array($params['district_id']) && !isEmpty($params['district_id'][0].value)) {
        $params['district_id'] = pluckKeyToArray($params['district_id'], 'value');
    }

    if (!isEmpty($params['loan']) && $params['loan'] === false) {
        delete $params['loan'];
    }

    if (!isEmpty($params['has_media']) && $params['has_media'] === false) {
        delete $params['has_media'];
    }

    if (!isEmpty($params['has_video']) && $params['has_video'] === false) {
        delete $params['has_video'];
    }

    if (!isEmpty($params['has_pool']) && $params['has_pool'] === false) {
        delete $params['has_pool'];
    }

    delete $params['checkRedirectToLanding'];
    delete $params['work_scope'];

    if (!isEmpty($params['city_id']) && Number($params['city_id']) === 259) {
        return await generateSearchTitleTehran($params, asPath);
    }

    const searchWidgetTitle = await getSearchWidgetTitle($params);

    const villaTypeTitle = (!isEmpty($params['villa_types'])) ? ' ' + getVillaTypes($params['villa_types']) : '';
    const hasPoolTitle = (!isEmpty($params['has_pool']) && $params['has_pool']) ? 'استخردار' : '';

    const loanTitle = (!isEmpty($params['loan']) && $params['loan'] !== false) ? ' با وام' : '';

    const loanAlternativeTitle = (!isEmpty(loanTitle) && $params['loan'] !== false) ? ' وام دار' : '';

    let cityName = 'همه شهرها';
    let city_id = $params['city_id'];

    if (!isEmpty($params['city_id'])) {
        const city = await getCityById(Number($params['city_id']));

        if (!isEmpty(city)) {
            cityName = city.name;
        }
    }

    let mainTitle = '';
    let pageTitle = '';
    let pageDescription = '';
    let verbose = '';
    let subTitle = '';
    let mainTitleIsLong = false;
    let breadcrumbListTitles = {};

    let typeNames = '';
    if (!isEmpty($params['types']) && is_array($params['types'])) {
        await getPropertyTypesByCityId(city_id).then(result => {
            typeNames = getTypeByKey(result.types, array_unique($params['types']))
        });

        mainTitle += (is_array(typeNames) ? typeNames.join(' ') + ' ' : '');
        mainTitle += (!isEmpty(villaTypeTitle) ? villaTypeTitle + ' ' : '');
        mainTitle += (!isEmpty(hasPoolTitle) ? hasPoolTitle + ' ' : '');

        pageDescription += 'لیست ' + typeNames.join(' ') + ' '
    }

    let dealTypeName = '';

    if (!isEmpty($params['deal_type'])) {
        dealTypeName = getSearchiDealTypes($params['deal_type']);

        if (dealTypeName === 'خرید') {
            dealTypeName = 'خرید فروش';
        }

        mainTitle = dealTypeName + ' ' + mainTitle;
        pageDescription += 'برای ' + dealTypeName + ' ';
    }

    breadcrumbListTitles[1] = mainTitle;

    let districtsName = '';
    if (!isEmpty($params['district_id'])) {
        const districtIds = array_unique($params['district_id']);

        await getDistricts(city_id).then(result => {
            const selectedDistricts = getDistrictByIds(result.districts, districtIds);

            if (!isEmpty(selectedDistricts) && selectedDistricts.length) {
                districtsName = selectedDistricts.join('، ');
                mainTitle += 'در ' + districtsName + ' ';
                breadcrumbListTitles[2] = selectedDistricts[0];
            }
        });
    }

    if (!isEmpty(districtsName)) {
        if (districtsName.search(cityName) === -1) {
            mainTitle += cityName;
        }
    } else {
        mainTitle += (isEmpty(districtsName) ? 'در ' : '') + cityName;
    }

    pageTitle = mainTitle;

    // convert "ویلا" to "ویلا و خانه ویلایی" in north cities in pageTitle and pageDescription
    const northCities = await getNorthCitiesIds();

    if (inArray(city_id, northCities) && !isEmpty($params['types']) && $params['types'].length === 1 && $params['types'][0] === 'villa.house') {
        pageTitle = str_replace('ویلا', 'ویلا و خانه ویلایی', pageTitle);
        pageDescription = str_replace('ویلا', 'ویلا و خانه ویلایی', pageDescription);
    }

    if (!isEmpty($params['deal_type']) && !isEmpty($params['types']) && $params['types'].length === 1 && !isEmpty(typeNames)) {
        const forSale = $params['deal_type'] === 'sale';
        if (forSale) {
            let newTypeNames = typeNames.join(' ');
            if (newTypeNames === 'آپارتمان') {
                newTypeNames = 'خانه';
            }

            pageTitle += (!isEmpty(loanTitle) ? loanTitle : '') + ' - قیمت ' + newTypeNames + ' در ' + ((!isEmpty(districtsName) ? districtsName + ' ' : '')) + cityName;
        } else {
            const forRent = $params['deal_type'] === 'rent';
            const isApartment = $params['types'][0] === 'apartment';

            if (forRent && isApartment) {
                pageTitle += ' - اجاره خانه در ' + (!isEmpty(districtsName) ? districtsName + ' ' : '') + cityName;
            }
        }
    }

    pageDescription += ' در ' + (!isEmpty(districtsName) ? districtsName + ' ' : '') + cityName + ' ' + loanTitle
        + ' همراه با عکس و قیمت های مناسب. اطلاع از قیمت های کارشناسی ملک' + loanAlternativeTitle + ' در ' +
        (!isEmpty(districtsName) ? districtsName + ' و شهر ' : '') + cityName + ' و مناطق مختلف آن و معرفی مشاورین متخصص';
    breadcrumbListTitles[0] = 'املاک ' + cityName;

    if (!isEmpty(loanTitle)) {
        mainTitle += '، ' + loanTitle;
        pageTitle += '، ' + loanTitle;
        breadcrumbListTitles[7] = loanTitle;
    }

    if (!isEmpty($params['deal_type']) && !isEmpty($params['types']) && $params['types'].length === 1 && !isEmpty(typeNames)) {
        const dealiType = getSearchiDealTypes($params['deal_type']);
        const type = typeNames.join(' ');

        verbose = 'قیمت ' + type + ' ' + dealiType + ' در ' + cityName + ' ' + loanTitle + ' ' + (!isEmpty(districtsName) ? ' نزدیک ' + districtsName : '')
    }

    const infrastructureAreaTitle = await getAreaRangeTitle($params, 'infrastructure_area', 'زیربنا');
    if (!isEmpty(infrastructureAreaTitle)) {
        mainTitle += '، ' + infrastructureAreaTitle;
        pageTitle += '، ' + infrastructureAreaTitle;
        breadcrumbListTitles[5] = infrastructureAreaTitle;
    }

    const landAreaTitle = await getAreaRangeTitle($params, 'land_area', 'متراژ زمین');
    if (!isEmpty(landAreaTitle)) {
        mainTitleIsLong = true;
        mainTitle += '، ' + landAreaTitle;
        pageTitle += '، ' + landAreaTitle;
        breadcrumbListTitles[6] = landAreaTitle;
    }

    let priceTitle = '';
    if (!isEmpty($params['deal_type']) && ($params['deal_type'] === 'mortgage' || $params['deal_type'] === 'rent')) {
        priceTitle = getPriceRangeTitle($params, 'mortgage', 'رهن');
        if (!isEmpty(priceTitle)) {
            mainTitleIsLong = true;
            mainTitle += '، ' + priceTitle;
            pageTitle += '، ' + priceTitle;
            breadcrumbListTitles[3] = priceTitle;
        }

        priceTitle = getPriceRangeTitle($params, 'rent', 'اجاره');
        if (!isEmpty(priceTitle)) {
            mainTitleIsLong = true;
            mainTitle += '، ' + priceTitle;
            pageTitle += '، ' + priceTitle;
            breadcrumbListTitles[4] = priceTitle;
        }
    } else {
        priceTitle = getPriceRangeTitle($params, 'price', 'قیمت');
        if (!isEmpty(priceTitle)) {
            mainTitleIsLong = true;
            mainTitle += '، ' + priceTitle;
            pageTitle += '، ' + priceTitle;
            breadcrumbListTitles[3] = priceTitle;
        }
    }

    const ageTitle = getAgeRangeTitle($params);
    if (!isEmpty(ageTitle)) {
        mainTitleIsLong = true;
        mainTitle += '، ' + ageTitle;
        pageTitle += '، ' + ageTitle;
        breadcrumbListTitles[3] = ageTitle;
    }

    if (!isEmpty($params['bedrooms'])) {
        if (Array.isArray($params['bedrooms']) && $params['bedrooms'].length) {
            subTitle += $params['bedrooms'].join(' و ') + ' خوابه به بالا';
        } else if (typeof $params['bedrooms'] === "number" && $params['bedrooms'] > 0) {
            subTitle += '، ' + $params['bedrooms'] + ' خوابه به بالا';
        }
    }

    if (!isEmpty($params['floors'])) {
        if (Array.isArray($params['floors']) && $params['floors'].length) {
            subTitle += '، طبقه ' + getFloorNames($params['floors']).join(' و ');
        } else if (typeof $params['floors'] === "number" && $params['floors'] > 0) {
            subTitle += '، طبقه ' + getFloorNames($params['floors'])[0];
        }
    }

    if (!isEmpty($params['deeds'])) {
        if (Array.isArray($params['deeds']) && $params['deeds'].length) {
            subTitle += '، سند ' + getDeeds($params['deeds']).join(' و ');
        } else if (typeof $params['deeds'] === "number" && $params['deeds'] > 0) {
            subTitle += '، سند ' + getDeeds($params['deeds'])[0];
        }
    }

    if (!isEmpty($params['facilities'])) {
        let facilityLists = ['parking', 'warehouse', 'elevator'];

        if (Array.isArray($params['facilities']) && $params['facilities'].length) {
            let facilities = $params['facilities'];

            let getFacilitiesTitles = getFacilitiesPersian(facilities);
            if (!isEmpty(getFacilitiesTitles) && getFacilitiesTitles.length > 0) {
                subTitle += '، با ';
                for (let key in getFacilitiesTitles) {
                    subTitle += getFacilitiesTitles[key][1] + (key < getFacilitiesTitles.length ? ' و ' : '');
                }
            }

            for (let item of facilities) {
                switch (item) {
                    case 'one_unit_in_floor' :
                        subTitle += ' تک‌واحدی ';
                        break;
                    case 'has_loan' :
                        subTitle += ' وام‌دار ';
                        break;
                    case 'without_landlord' :
                        subTitle += ' بدون مالک ';
                        break;
                    case 'exchangeable' :
                        subTitle += ' فقط معاوضه ';
                        break;
                    case 'convertible' :
                        subTitle += ' قابل تبدیل ';
                        break;
                }
            }
        } else {
            let item = $params['facilities'];
            if (inArray(item, facilityLists)) {
                subTitle += '، با ' + getFacilitiesPersian($params['facilities']);
            } else {
                switch (item) {
                    case 'one_unit_in_floor' :
                        subTitle += ' تک‌واحدی ';
                        break;
                    case 'has_loan' :
                        subTitle += ' وام‌دار ';
                        break;
                    case 'without_landlord' :
                        subTitle += ' بدون مالک ';
                        break;
                    case 'convertible' :
                        subTitle += ' قابل تبدیل ';
                        break;
                }
            }
        }
    }

    if (mainTitleIsLong) {
        pageDescription = mainTitle;
    }

    if (!isEmpty(subTitle)) {
        breadcrumbListTitles[7] = subTitle;
        pageDescription += subTitle;
    }

    if (!isEmpty($params['page']) && $params['page'] > 1) {
        let page = $params['page'];
        mainTitle += ' - صفحه ' + page;
    }

    if (mainTitleIsLong && !isEmpty(verbose)) {
        pageDescription += ' ' + verbose;
    }

    pageTitle = str_replace('پیش خرید', 'پیش فروش و پیش خرید', pageTitle);
    pageDescription = str_replace('پیش خرید', 'پیش فروش و پیش خرید', pageDescription);


    if (!isEmpty(searchWidgetTitle)) {
        mainTitle = searchWidgetTitle.caption;

        if (!isEmpty(searchWidgetTitle.title)) {
            pageTitle = searchWidgetTitle.title;
        }

        if (!isEmpty(searchWidgetTitle.label)) {
            pageDescription = searchWidgetTitle.label;
        }
    }

    if (!process.browser) {
        breadcrumbListTitles = await createBreadcrumbList(asPath, breadcrumbListTitles)
    }

    if ($params['city_id'] && ObjectLength($params) === 1) {
        pageTitle = 'املاک ' + cityName + ' - خرید خانه ' + cityName + ' - فروش آپارتمان - رهن اجاره خانه ' + cityName;
        pageDescription = 'املاک ' + cityName + ' ۲نبش خرید فروش آپارتمان ' + cityName + ' رهن اجاره خانه ' + cityName + ' پیش فروش آپارتمان ' + cityName + ' معاوضه ملک و زمین ' + cityName;
    }


    return {
        main: mainTitle,
        pageTitle: pageTitle,
        pageDescription: pageDescription,
        subTitle: subTitle,
        breadcrumbList: breadcrumbListTitles
    }
};

export const generateSearchTitleTehran = async ($params, asPath) => {
    const searchWidgetTitle = await getSearchWidgetTitle($params);

    const villaTypeTitle = (!isEmpty($params['villa_types'])) ? ' ' + getVillaTypes($params['villa_types']) : '';

    const loanTitle = (!isEmpty($params['loan']) && $params['loan'] !== false) ? ' با وام' : '';

    const loanAlternativeTitle = (!isEmpty(loanTitle) && $params['loan'] !== false) ? ' وام دار' : '';

    let cityName = 'همه شهرها';
    let city_id = $params['city_id'];

    if (!isEmpty($params['city_id'])) {
        await getCityById(Number($params['city_id'])).then(city => {
            if (!isEmpty(city)) {
                cityName = city.name;
            }
        });
    }

    const pricesArray = getDefaultPrices();
    const infrastructureAreaArray = getDefaultInfrastructureArea();
    let isCannibal = false;
    if (city_id === 259
        && !isEmpty($params['types']) && $params['types'].length === 1 && $params['types'][0] === 'apartment'
        && !isEmpty($params['deal_type']) && $params['deal_type'] === 'sale'
        && (
            (isEmpty($params['min_price']) && !isEmpty($params['max_price']) && inArray($params['max_price'], pricesArray))
            || (isEmpty($params['min_infrastructure_area']) && !isEmpty($params['max_infrastructure_area']) && inArray($params['max_infrastructure_area'], infrastructureAreaArray))
        )
    ) {
        isCannibal = true;
    }

    let mainTitle = '';
    let pageTitle = '';
    let pageDescription = '';
    let verbose = '';
    let subTitle = '';
    let mainTitleIsLong = false;
    let breadcrumbListTitles = {};

    let typeNames = '';
    if (!isEmpty($params['types'])) {
        await getPropertyTypesByCityId(city_id).then(result => {
            typeNames = getTypeByKey(result.types, $params['types']);
        });

        mainTitle += typeNames.join(' ') + ' ' + (!isEmpty(villaTypeTitle) ? villaTypeTitle + ' ' : '');
        pageDescription += 'لیست ' + typeNames.join(' ') + ' '
    }

    let dealTypeName = '';
    if (!isEmpty($params['deal_type'])) {
        dealTypeName = getSearchiDealTypes($params['deal_type']);

        mainTitle = dealTypeName + ' ' + mainTitle;
        pageDescription += 'برای ' + dealTypeName + ' ';
    }

    breadcrumbListTitles[1] = mainTitle;

    let infrastructureAreaTitle = await getAreaRangeTitle($params, 'infrastructure_area', 'زیربنا');
    let priceTitle = '';

    if (isCannibal) {

        if (!isEmpty(infrastructureAreaTitle)) {
            infrastructureAreaTitle = str_replace('زیربنا تا ', '', infrastructureAreaTitle);
            infrastructureAreaTitle = str_replace('زیربنا ', '', infrastructureAreaTitle);
            infrastructureAreaTitle = str_replace('متر', 'متری', infrastructureAreaTitle);

            mainTitle += infrastructureAreaTitle + ' ';
            pageTitle += infrastructureAreaTitle + ' ';
            breadcrumbListTitles[5] = infrastructureAreaTitle;
        }

        priceTitle = getPriceRangeTitle($params, 'price', 'قیمت');
        if (!isEmpty(priceTitle)) {
            priceTitle = str_replace('قیمت ', '', priceTitle);

            mainTitle += priceTitle + ' ';
            pageTitle += priceTitle + ' ';
            breadcrumbListTitles[3] = priceTitle;
        }
    }


    let districtsName = '';
    if (!isEmpty($params['district_id'])) {
        const districtIds = array_unique($params['district_id']);

        await getDistricts(city_id).then(result => {
            const selectedDistricts = getDistrictByIds(result.districts, districtIds);

            if (!isEmpty(selectedDistricts) && selectedDistricts.length) {
                districtsName = selectedDistricts.join('، ');
                mainTitle += 'در ' + districtsName + ' ';
                breadcrumbListTitles[2] = selectedDistricts[0];
            }
        });
    }

    if (!isEmpty(districtsName)) {
        if (districtsName.search(cityName) === -1) {
            mainTitle += cityName;
        }
    } else {
        mainTitle += (isEmpty(districtsName) ? 'در ' : '') + cityName;
    }


    pageTitle = mainTitle;

    if (!isEmpty($params['deal_type']) && !isEmpty($params['types']) && $params['types'].length === 1 && !isEmpty(typeNames)) {
        const forSale = (dealTypeName.indexOf('خرید فروش') !== -1);
        if (forSale) {
            let newTypeNames = typeNames.join(' ');
            if (newTypeNames === 'آپارتمان') {
                newTypeNames = 'خانه';
            }

            pageTitle += (!isEmpty(loanTitle) ? loanTitle : '') + ' - قیمت ' + newTypeNames + (!isCannibal ? +' در ' + ((!isEmpty(districtsName) ? (districtsName + ' ') : '') + cityName) : '')
        } else {
            const forRent = $params['deal_type'] === 'rent';
            const isApartment = $params['types'][0] === 'apartment';

            if (forRent && isApartment) {
                pageTitle += ' - اجاره خانه در ' + (!isEmpty(districtsName) ? districtsName + ' ' : '') + cityName;
            }
        }
    }

    pageDescription += ' در ' + (!isEmpty(districtsName) ? districtsName + ' ' : '') + cityName + ' ' + loanTitle
        + ' همراه با عکس و قیمت های مناسب. اطلاع از قیمت های کارشناسی ملک' + loanAlternativeTitle + ' در ' +
        (!isEmpty(districtsName) ? districtsName + ' و شهر ' : '') + cityName + ' و مناطق مختلف آن و معرفی مشاورین متخصص';
    breadcrumbListTitles[0] = 'املاک ' + cityName;

    if (!isEmpty(loanTitle)) {
        mainTitle += '، ' + loanTitle;
        pageTitle += '، ' + loanTitle;
        breadcrumbListTitles[7] = loanTitle;
    }

    if (!isEmpty($params['deal_type']) && !isEmpty($params['types']) && $params['types'].length === 1 && !isEmpty(typeNames)) {
        const dealiType = getSearchiDealTypes($params['deal_type']);
        const type = typeNames.join(' ');

        verbose = 'قیمت ' + type + ' ' + dealiType + ' در ' + cityName + ' ' + loanTitle + ' ' + (!isEmpty(districtsName) ? ' نزدیک ' + districtsName : '')
    }

    if (!isCannibal) {
        if (!isEmpty(infrastructureAreaTitle)) {
            mainTitle += '، ' + infrastructureAreaTitle;
            pageTitle += '، ' + infrastructureAreaTitle;
            breadcrumbListTitles[5] = infrastructureAreaTitle;
        }

        const landAreaTitle = await getAreaRangeTitle($params, 'land_area', 'متراژ زمین');
        if (!isEmpty(landAreaTitle)) {
            mainTitleIsLong = true;
            mainTitle += '، ' + landAreaTitle;
            pageTitle += '، ' + landAreaTitle;
            breadcrumbListTitles[6] = landAreaTitle;
        }


        if (!isEmpty($params['deal_type']) && ($params['deal_type'] === 'mortgage' || $params['deal_type'] === 'rent')) {
            priceTitle = getPriceRangeTitle($params, 'mortgage', 'رهن');
            if (!isEmpty(priceTitle)) {
                mainTitleIsLong = true;
                mainTitle += '، ' + priceTitle;
                pageTitle += '، ' + priceTitle;
                breadcrumbListTitles[3] = priceTitle;
            }

            priceTitle = getPriceRangeTitle($params, 'rent', 'اجاره');
            if (!isEmpty(priceTitle)) {
                mainTitleIsLong = true;
                mainTitle += '، ' + priceTitle;
                pageTitle += '، ' + priceTitle;
                breadcrumbListTitles[4] = priceTitle;
            }
        } else {
            priceTitle = getPriceRangeTitle($params, 'price', 'قیمت');
            if (!isEmpty(priceTitle)) {
                mainTitleIsLong = true;
                mainTitle += '، ' + priceTitle;
                pageTitle += '، ' + priceTitle;
                breadcrumbListTitles[3] = priceTitle;
            }
        }
    }

    const ageTitle = getAgeRangeTitle($params);
    if (!isEmpty(ageTitle)) {
        mainTitleIsLong = true;
        mainTitle += '، ' + ageTitle;
        pageTitle += '، ' + ageTitle;
        breadcrumbListTitles[3] = ageTitle;
    }

    if (!isEmpty($params['bedrooms'])) {
        if (Array.isArray($params['bedrooms']) && $params['bedrooms'].length) {
            subTitle += $params['bedrooms'].join(' و ') + ' خوابه به بالا';
        } else if (typeof $params['bedrooms'] === "number" && $params['bedrooms'] > 0) {
            subTitle += '، ' + $params['bedrooms'] + ' خوابه به بالا';
        }
    }

    if (!isEmpty($params['floors'])) {
        if (Array.isArray($params['floors']) && $params['floors'].length) {
            subTitle += '، طبقه ' + getFloorNames($params['floors']).join(' و ');
        } else if (typeof $params['floors'] === "number" && $params['floors'] > 0) {
            subTitle += '، طبقه ' + getFloorNames($params['floors'])[0];
        }
    }

    if (!isEmpty($params['deeds'])) {
        if (Array.isArray($params['deeds']) && $params['deeds'].length) {
            subTitle += '، سند ' + getDeeds($params['deeds']).join(' و ');
        } else if (typeof $params['deeds'] === "number" && $params['deeds'] > 0) {
            subTitle += '، سند ' + getDeeds($params['deeds'])[0];
        }
    }

    if (!isEmpty($params['facilities'])) {
        let facilityLists = ['parking', 'warehouse', 'elevator'];

        if (Array.isArray($params['facilities']) && $params['facilities'].length) {
            let facilities = $params['facilities'];

            let getFacilitiesTitles = getFacilitiesPersian(facilities);
            if (!isEmpty(getFacilitiesTitles) && getFacilitiesTitles.length > 0) {
                subTitle += '، با ';
                for (let key in getFacilitiesTitles) {
                    subTitle += getFacilitiesTitles[key][1] + (key < getFacilitiesTitles.length ? ' و ' : '');
                }
            }

            for (let item of facilities) {
                switch (item) {
                    case 'one_unit_in_floor' :
                        subTitle += ' تک‌واحدی ';
                        break;
                    case 'has_loan' :
                        subTitle += ' وام‌دار ';
                        break;
                    case 'without_landlord' :
                        subTitle += ' بدون مالک ';
                        break;
                    case 'exchangeable' :
                        subTitle += ' فقط معاوضه ';
                        break;
                    case 'convertible' :
                        subTitle += ' قابل تبدیل ';
                        break;
                }
            }
        } else {
            let item = $params['facilities'];
            if (inArray(item, facilityLists)) {
                subTitle += '، با ' + getFacilitiesPersian($params['facilities']);
            } else {
                switch (item) {
                    case 'one_unit_in_floor' :
                        subTitle += ' تک‌واحدی ';
                        break;
                    case 'has_loan' :
                        subTitle += ' وام‌دار ';
                        break;
                    case 'without_landlord' :
                        subTitle += ' بدون مالک ';
                        break;
                    case 'convertible' :
                        subTitle += ' قابل تبدیل ';
                        break;
                }
            }
        }
    }

    if (mainTitleIsLong) {
        pageDescription = mainTitle;
    }

    if (!isEmpty(subTitle)) {
        breadcrumbListTitles[7] = subTitle;
        pageDescription += subTitle;
    }

    if (!isEmpty($params['page']) && $params['page'] > 1) {
        let page = $params['page'];
        mainTitle += ' - صفحه ' + page;
    }

    if (mainTitleIsLong && !isEmpty(verbose)) {
        pageDescription += ' ' + verbose;
    }

    pageTitle = str_replace('پیش خرید', 'پیش فروش و پیش خرید', pageTitle);
    pageDescription = str_replace('پیش خرید', 'پیش فروش و پیش خرید', pageDescription);

    if (!isEmpty(searchWidgetTitle)) {
        mainTitle = searchWidgetTitle.caption;

        if (!isEmpty(searchWidgetTitle.title)) {
            pageTitle = searchWidgetTitle.title;
        }

        if (!isEmpty(searchWidgetTitle.label)) {
            pageDescription = searchWidgetTitle.label;
        }
    }

    if (!process.browser) {
        breadcrumbListTitles = await createBreadcrumbList(asPath, breadcrumbListTitles)
    }

    if ($params['city_id'] && ObjectLength($params) === 1) {
        pageTitle = 'املاک تهران | پربازدیدترین سایت تخصصی املاک تهران';
        pageDescription = 'آگهی‌های املاک تهران در سایت ۲نبش؛ پربازدیدترین سایت املاک تهران، و راهی سریع و مطمئن برای خانه‌دار شدن';
    }


    return {
        main: mainTitle,
        pageTitle: pageTitle,
        pageDescription: pageDescription,
        subTitle: subTitle,
        breadcrumbList: breadcrumbListTitles
    }
};

export async function createBreadcrumbList(path, breadcrumbListTitles) {
    let breadcrumbListUrls = decodeURI(path);
    breadcrumbListUrls = breadcrumbListUrls.split('/');
    delete breadcrumbListUrls[0];

    breadcrumbListUrls = array_unique(breadcrumbListUrls);

    let cityNameLink = '/' + breadcrumbListUrls[0];

    const checkRedirected = await checkUrlParams(cityNameLink, linkTypes.SEARCH);
    if (checkRedirected && checkRedirected.redirect) {
        delete breadcrumbListUrls[0]
    }

    let breadcrumbList = [];
    let tmpUrl = '';

    for (let key in breadcrumbListUrls) {
        let breadcrumbListUrl = breadcrumbListUrls[key];

        if (!isEmpty(breadcrumbListTitles[key])) {
            tmpUrl += '/' + encodeURI(breadcrumbListUrl);

            breadcrumbList.push({
                url: tmpUrl,
                name: is_array(breadcrumbListTitles[key]) ? breadcrumbListTitles[key].join('، ') : breadcrumbListTitles[key]
            })
        }
    }

    return breadcrumbList;
}

function get_redirected_url() {

}

export async function generateSearchHotLinks(selected_filters, asPath = null) {
    let $params = JSON.parse(JSON.stringify(selected_filters)); // deep copy
    //const saleDealTypes = ['sale', 'pre_sale', 'exchange', 'participation'];
    const rentDealTypes = ['mortgage', 'rent'];

    let $result = [];

    const deal_type = !isEmpty($params['deal_type']) ? $params['deal_type'] : 'sale';
    const $dealType = inArray(deal_type, rentDealTypes) ? 'rent' : 'sale';
    let $type = 'apartment';

    if ((!isEmpty($params['types']) && $params['types'].length)) {
        $type = $params['types'][0];
    } else {
        const cityTypes = await getPropertyTypesByCityId($params['city_id']);

        if (!isEmpty(cityTypes) && !isEmpty(cityTypes.types) && cityTypes.types.length) {
            $type = cityTypes.types[0].name;
        } else {
            $type = 'apartment';
        }
    }

    const city = await getCityById($params['city_id']);

    if (!isEmpty(city)) {
        const typeUrl = getUrlTypes($type);
        const typeName = await getTypeCaptionByName($type, city.id);
        const dealTypeUrl = getUrlDealTypes($dealType);
        const dealTypeName = getDealTypeSearchName($dealType);

        if (!isEmpty($params['district_id']) && $params['district_id'].length) {
            for (let district of $params['district_id']) {
                let district_name = '';

                if (typeof district === "number") {
                    district = await getDistrict(district);
                    if (district) {
                        district_name = district.name;
                    }
                } else {
                    district_name = !isEmpty(district.label) ? district.label : district.name;
                }

                let districtUrl = '';

                if (city.type === 'area' && !isEmpty(district_name)) {
                    districtUrl = generateSearchUrl(district_name, typeUrl, dealTypeUrl);
                } else {
                    districtUrl = generateSearchUrl(city.name, typeUrl, dealTypeUrl, district_name);
                }

                let urlPath = (!process.browser) ? asPath : Router.router.asPath;
                urlPath = !isEmpty(urlPath) ? urlPath.split('?')[0] : '';

                if (!isEmpty(districtUrl) && districtUrl !== decodeURI(urlPath)) {
                    const tmp = {
                        'title': dealTypeName + ' ' + typeName + ' در ' + district_name,
                        'url': districtUrl
                    };

                    $result.push(tmp);
                }
            }
        }

        //const cityLink = generateSearchUrl(city.name, typeUrl, dealTypeUrl);

        if (!isEmpty(city) && $dealType === 'sale' && $type === 'villa.house') {
            if (city.id === 3198) {
                const tmp = {
                    'title': 'خرید زمین در شمال',
                    'url': '/املاک-شمال/خرید-فروش-زمین'
                };

                $result.push(tmp);
            } else {
                const northCitiesIds = await getNorthCitiesIds();

                if (inArray(city.id, northCitiesIds)) {
                    const tmp = {
                        'title': 'خرید ویلا در شمال',
                        'url': '/املاک-شمال/خرید-فروش-ویلا'
                    };

                    $result.push(tmp);
                }
            }
        }
    }

    return $result
}

export async function getSearchHotLinks(selected_filters, selectedFiltersDistrictIds, isBadeSaba = false, asPath = null) {
    let links = [];
    const {city_id, deal_type, types} = selected_filters;
    const urlQuery = (isBadeSaba ? '?badesaba=true' : '');

    let aroundDistricts = null;

    if (!isEmpty(selectedFiltersDistrictIds) && selectedFiltersDistrictIds.length) {
        aroundDistricts = await getTopNearestDistricts(selectedFiltersDistrictIds, 24);
    } else {
        aroundDistricts = await getTopCrowdedDistricts(city_id, 24);
    }

    let $params = {
        city_id: city_id,
        deal_type: deal_type,
        types: types,
        district_id: (!isEmpty(aroundDistricts) && !isEmpty(aroundDistricts.districts)) ? aroundDistricts.districts : null
    };

    const defaultLinks = await generateSearchHotLinks($params, asPath);

    if (defaultLinks.length) {
        for (let link of defaultLinks) {
            links.push({href: link.url + urlQuery, hrefAs: link.url + urlQuery, title: link.title})
        }
    }

    return links;
}

export async function getCanonicalSearchWidget(params) {
    let $params = JSON.parse(JSON.stringify(params)); // deep copy

    delete $params['work_scope'];
    delete $params['selected_range'];
    delete $params['checkRedirectToLanding'];
    delete $params['properties'];

    if (!isEmpty($params['district_id']) && is_array($params['district_id']) && $params['district_id'].length < 1) {
        delete $params['district_id'];
    }

    if (!isEmpty($params['loan']) && $params['loan'] === false) {
        delete $params['loan'];
    }

    if (!isEmpty($params['has_media']) && $params['has_media'] === false) {
        delete $params['has_media'];
    }

    if (!isEmpty($params['has_video']) && $params['has_video'] === false) {
        delete $params['has_video'];
    }

    if (!isEmpty($params['has_pool']) && $params['has_pool'] === false) {
        delete $params['has_pool'];
    }

    if (!isEmpty($params['work_scope']) && $params['work_scope'] === false) {
        delete $params['work_scope'];
    }

    let city_id = $params['city_id'];
    let district_id = $params['district_id'];

    const widgetParam = {
        type: 'search_landing',
        page: 'properties',
        section: 'properties',
        city_id: city_id,
        district_id: district_id,
        count: 10
    };

    const searchLandingWidgets = await getWidgets(widgetParam);

    let selectedWidget = null;

    if (!isEmpty(searchLandingWidgets) && searchLandingWidgets.widgets && searchLandingWidgets.widgets.length) {
        Object.keys(searchLandingWidgets.widgets).forEach(key => {
            const widget = searchLandingWidgets.widgets[key];
            const showWidget = widgetFilters(widget, $params);
            if (showWidget) {
                selectedWidget = widget;
            }
        });
    }

    return selectedWidget
}

/**
 * @param params {Object}
 * @param isBadeSaba {Boolean}
 *
 * @return Object
 * */
export const getCitiesItemsFilterOptions = async (params, isBadeSaba = false) => {
    const city_id = !isEmpty(params['city_id']) ? params['city_id'] : getDefaultCity();
    const district_id = !isEmpty(params['district_id']) ? params['district_id'] : [];
    const deal_type = !isEmpty(params['deal_type']) ? params['deal_type'] : '';
    const types = !isEmpty(params['types']) ? params['types'] : [];

    const cities = await citiesSelection();

    const cities_items = await UpdateSelectionOptions(cities.options, {items: [city_id]});

    const districts = await getDistrictOptions(city_id);
    const new_districts = await UpdateSelectionOptions(districts.options, {items: district_id}, true);

    const TypesItems = await getTypesOptions(city_id, deal_type);
    const new_types = await UpdateSelectionOptions(TypesItems.options, {items: types});

    const dealTypes = await getDealTypeOptions(city_id, isBadeSaba);
    const new_deal_types = await UpdateSelectionOptions(dealTypes.options, {items: [deal_type]});

    return {
        cities: cities_items,
        districts: new_districts,
        types: new_types,
        deal_type: new_deal_types
    }
};

export async function handleLandingsDataSsr(urlParams, checkRedirectToLanding) {
    const propertiesLandings = [
        'shomal', 'mashhad', 'tehran',
        'north_city', 'holyShrine',
    ];

    let data = {
        cityAreasWidget: null,
        cityPropertiesWidget: null,
        specialCities: null,
        mostActiveRealtorsLists: null,
    };

    if (inArray(urlParams.city_id, [207, 259])) {
        let districtsParams = { // for city 207
            type: 'static_links',
            page: 'home',
            section: (urlParams.city_id === 207) ? 'related_districts_1' : 'related_cities',
            city_id: urlParams.city_id,
            count: 10
        };

        const result = await getWidgets(districtsParams);
        data['cityAreasWidget'] = (!isEmpty(result) && result.widgets) ? result.widgets : []
    }

    const citiesPropertyTypeVilla = [
        3198, // شمال
        ...northCitiesLanding
    ];

    let propertiesParams = {
        city_id: urlParams.city_id,
        types: inArray(urlParams.city_id, citiesPropertyTypeVilla) ? ['villa'] : ['apartment'],
        deal_type: 'sale',
        sort: 'boosted_at',
        has_media: 1,
        exclude_archived: 1,
        count: 8
    };

    if (!isEmpty(checkRedirectToLanding) && !isEmpty(checkRedirectToLanding.district_id)) {
        propertiesParams['district_id'] = [checkRedirectToLanding.district_id]
    }

    if (inArray(checkRedirectToLanding.landing, propertiesLandings)) {
        await getProperties(1, null, propertiesParams, false).then(result => {
            data['cityPropertiesWidget'] = result.properties
        });
    }

    if (checkRedirectToLanding.landing === 'cities_home') {
        const saleAndRentProperties = await getCitySaleAndRentProperties(urlParams.city_id);

        data['citySalePropertiesWidget'] = saleAndRentProperties.citySaleProperties;
        data['cityRentPropertiesWidget'] = saleAndRentProperties.cityRentProperties;
        data['cityHasVideoPropertiesWidget'] = saleAndRentProperties.cityHasVideoProperties;
    }

    if (inArray(urlParams.city_id, citiesPropertyTypeVilla)) {
        const specialCitiesParams = {
            type: 'static_links',
            page: 'properties',
            section: 'related_cities',
            city_id: 3198,
            properties_types: 'villa',
            properties_deal_types: 'sale',
            count: 25
        };

        const specialCitiesResult = await getWidgets(specialCitiesParams);

        data['specialCities'] = (!isEmpty(specialCitiesResult) && specialCitiesResult.widgets) ? specialCitiesResult.widgets : [];
    }

    if (inArray(urlParams.city_id, northCitiesLanding)) {
        data['getNorthCityData'] = await getNorthCityData(urlParams.city_id)
    }

    data['faqsList'] = await getSearchFaq(urlParams, (!isEmpty(checkRedirectToLanding.type) && checkRedirectToLanding.type === 'home') ? 'home' : 'properties');

    data['ssrBrandingText'] = await getSearchBrandingText(urlParams);

    return data;
}

export async function getCitySaleAndRentProperties(city_id) {
    let citySaleProperties = [];
    let cityRentProperties = [];
    let cityHasVideoProperties = [];

    /*const cityPropertiesWidgetParams = {
        type: 'properties',
        page: 'home',
        section: 'properties',
        city_id: city_id,
        count: 8
    };

    await getWidgets(cityPropertiesWidgetParams).then(result => {
        citySaleProperties = result.widgets;
    });

    cityPropertiesWidgetParams.section = 'rent_properties';
    await getWidgets(cityPropertiesWidgetParams).then(result => {
        cityRentProperties = result.widgets;
    });*/

    citySaleProperties = await getLandingCitySaleProperties(city_id);
    cityRentProperties = await getLandingCityRentProperties(city_id);
    cityHasVideoProperties = await getLandingCityHasVideoProperties(city_id);

    return {
        citySaleProperties: citySaleProperties,
        cityRentProperties: cityRentProperties,
        cityHasVideoProperties: cityHasVideoProperties,
    }
}

export async function getLandingCitySaleProperties(city_id) {
    let propertiesParams = {
        city_id: city_id,
        deal_type: 'sale',
        sort: 'boosted_at',
        has_media: 1,
        exclude_archived: 1,
        count: 8
    };

    try {
        const result = await getProperties(1, null, propertiesParams, false);

        return result.properties;
    } catch (e) {
        return []
    }
}

export async function getLandingCityRentProperties(city_id) {
    let propertiesParams = {
        city_id: city_id,
        deal_type: 'rent',
        sort: 'boosted_at',
        has_media: 1,
        exclude_archived: 1,
        count: 8
    };

    try {
        const result = await getProperties(1, null, propertiesParams, false);

        return result.properties;
    } catch (e) {
        return []
    }
}

export async function getLandingCityHasVideoProperties(city_id) {
    let propertiesParams = {
        city_id: city_id,
        sort: 'boosted_at',
        has_video: 1,
        exclude_archived: 1,
        count: 8
    };

    try {
        const result = await getProperties(1, null, propertiesParams, false);

        return result.properties;
    } catch (e) {
        return []
    }
}

export function checkRedirectNorthCitiesPropertyTypes(types) {
    const priorityItems = ['villa', 'land', 'garden', 'apartment', 'suite'];
    let results = [];

    for (let type of types) {
        if (!isEmpty(type) && type.indexOf('.') !== -1) {
            for (let merged of type.split('.')) {
                if (!isEmpty(merged) && inArray(merged, priorityItems)) {
                    results.push(type)
                }
            }
        } else if (!isEmpty(type) && inArray(type, priorityItems)) {
            results.push(type);
        }
    }

    let items = [];

    for (let item of priorityItems) {
        for (let result of results) {
            if (!isEmpty(result) && result.indexOf('.') !== -1) {
                for (let merged of result.split('.')) {
                    if (!isEmpty(merged) && merged === item) {
                        items.push(result)
                    }
                }
            } else if (!isEmpty(result) && result === item) {
                items.push(result);
            }
        }
    }

    return (items.length) ? [items[0]] : []
}

export function checkCanonicalLink(link) {
    let canonicalLink = link;
    const decodedLink = decodeURI(link);

    if (decodedLink.indexOf('مازندران') !== -1 && decodedLink !== '/املاک-مازندران') {
        canonicalLink = encodeURI(str_replace('مازندران', 'شمال', decodedLink));
    }

    return canonicalLink;
}

export function getSearchFaq(params, page = 'properties') {

    let $params = JSON.parse(JSON.stringify(params)); // deep copy

    let city_id = $params['city_id'];
    let district_id = $params['district_id'];

    const widgetParams = {
        type: 'content',
        page: page,
        section: 'faq',
        city_id: city_id,
        district_id: (!isEmpty(district_id)) ? district_id : '',
        count: 10
    };


    // We don't need to filter here because FAQs are displayed based on City and Page
    return new Promise((resolve, reject) => {
        getWidgets(widgetParams).then(result => {
            resolve(result.widgets ?? []);
        }).catch(err => {
            reject(err)
        })
    })
}


export async function getSearchBrandingText(params, showDefaultIfNull = true) {
    let $params = JSON.parse(JSON.stringify(params)); // deep copy

    let types = [];

    if (!isEmpty($params['types']) && $params['types'].length) {
        for (let type of $params['types']) {
            if (!isEmpty(type) && type.indexOf('.') !== -1) {
                for (let merged of type.split('.')) {
                    if (!isEmpty(merged)) {
                        types.push(merged)
                    }
                }
            } else if (!isEmpty(type)) {
                types.push(type);
            }
        }
    }

    if (types.length) {
        $params['types'] = types;
    } else {
        delete $params['types'];
    }

    let districtIds = [];
    if (!isEmpty($params['district_id']) && $params['district_id'].length) {
        for (let district of $params['district_id']) {
            if (typeof district.value !== "undefined") {
                districtIds.push(district.value)
            } else if (!isNaN(district)) {
                districtIds.push(district)
            }
        }
    }

    if (districtIds.length) {
        $params['district_id'] = districtIds;
    } else {
        delete $params['district_id'];
    }

    if (!isEmpty($params['loan']) && $params['loan'] === false) {
        delete $params['loan'];
    }

    if (!isEmpty($params['has_media']) && $params['has_media'] === false) {
        delete $params['has_media'];
    }

    if (!isEmpty($params['has_video']) && $params['has_video'] === false) {
        delete $params['has_video'];
    }

    if (!isEmpty($params['has_pool']) && $params['has_pool'] === false) {
        delete $params['has_pool'];
    }

    if (!isEmpty($params['work_scope']) && $params['work_scope'] === false) {
        delete $params['work_scope'];
    }

    let city_id = $params['city_id'];

    const widgetParams = {
        type: 'content',
        page: 'properties',
        section: 'branding_text',
        city_id: city_id,
        count: 10
    };

    let result = null;

    try {
        const response = await getWidgets(widgetParams);

        if (!isEmpty(response) && response.widgets && response.widgets.length) {
            Object.keys(response.widgets).forEach(key => {
                const widget = response.widgets[key];

                const showWidget = widgetFilters(widget, $params);

                if (showWidget) {
                    result = widget;
                }
            });
        }

    } catch (e) {
        result = null;
    }

    if (!result && showDefaultIfNull) {
        result = getDefaultBrandingText()
    }

    return result;
}

export function getDefaultBrandingText() {
    return {
        caption: '۲نبش؛ راهی سریع و مطمئن برای خانه‌دار شدن',
        content: `«2نبش» با تجربۀ 12 ساله‌ش، کاربردی‌ترین خدمات در حوزۀ املاک رو ارائه میده. ثبت آگهی‌های ملک، برندینگ مشاورین املاک و سرعت بخشیدن به معاملۀ خریداران و فروشندگان ملک، فقط بخشی از خدمات 2نبش در حوزۀ املاک به شماست. اگه مشاور املاک هستین، می‌تونین با پیوستن به جمع متخصص‌ترین مشاورین املاک، کسب‌وکارتون رو توسعه بدین و اگر هم مالک یا خریدار هستین، با 2نبش در کمترین زمان معامله‌ کنین`
    }
}